<template>
    <div :class="classes">
        <div class="Environment__heading">{{ environment.name }}</div>
        <a href="#"
           class="Environment__menu"
           v-if="environment.status == 'Offline'"
           v-show="showMenu"
           @click.self.prevent="toggleActions"
        >
            <div class="Environment__menu-actions" v-show="showActions">
                <ul class="Utility__list-unstyled">
                    <li><a href="#" @click.prevent="copyPreLive">Copy Pre-Live Data</a></li>
                    <li><a href="#" @click.prevent="swapEnvironments">Swap Environments</a></li>
                    <li><a href="#" @click.prevent="copyPreLiveAndSwap">Copy Pre-Live Data & Swap Environments</a></li>
                </ul>
            </div>
        </a>
        <a href="#"
           class="Environment__menu Environment__menu--pre-live"
           v-if="environment.status == 'Pre-Live'"
           v-show="showMenu"
           @click.self.prevent="toggleActions"
        >
            <div class="Environment__menu-actions Environment__menu-actions--pre-live" v-show="showActions">
                <ul class="Utility__list-unstyled">
                    <li><a href="#" @click.prevent="updateDate">Update Environment Date</a></li>
                </ul>
            </div>
        </a>
        <div class="Environment__body">
            <div class="Environment__info">
                <div class="Environment__body-row">
                    <strong>Status:</strong> {{ environment.status }}
                </div>
                <div class="Environment__body-row">
                    <strong>Running Version:</strong> {{ environment.version }}
                </div>
                <div class="Environment__body-row">
                    <strong>Data Up To:</strong> {{ formattedDataUpTo }}
                </div>
                <div class="Environment__body-row">
                    <strong>Last Updated:</strong> {{ formattedLastUpdated }}
                </div>
            </div>

            <div :class="updatesClasses" v-show="updating">
                <i class="fa fa-circle-o-notch fa-spin"></i> {{ updateMessage }}
            </div>

            <div class="Environment__updates Environment__updates--pre-live" v-if="manualUpdate">
                <div class="Form__group Form__group--environment">
                    <label class="Form__label Form__label--environment">Date Up To</label>
                    <masked-input type="text"
                                  class="Form__text Form__text--environment"
                                  :guide="true"
                                  :keep-char-positions="true"
                                  :mask="[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]"
                                  :pipe="autoCorrectedDatePipe"
                                  :show-mask="true"
                                  placeholderChar="_"
                                  v-model="manualDate"
                                  @keyup.enter.native="changeDate"
                                  ref="manualDate"
                    >
                    </masked-input>
                </div>
                <div class="Form__group Form__group--environment">
                    <a href="#" class="Button Button--environment" @click.prevent="changeDate">Update</a>
                    <a href="#" class="Button Button--environment" @click.prevent="cancelManualUpdate">Cancel</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import MaskedInput from 'vue-text-mask';
    import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe'

    export default {
        data() {
            return {
                environment: {
                    name: '',
                    status: '',
                    version: '',
                    dataUpTo: '',
                    lastUpdated: '',
                },
                showMenu: true,
                showActions: false,
                updating: false,
                updateMessage: '',
                manualUpdate: false,
                manualDate: '',
                autoCorrectedDatePipe: createAutoCorrectedDatePipe('dd/mm/yyyy'),
            }
        },

        components: {
            MaskedInput,
        },

        props: {
            environmentData: {
                type: Object,
                required: true,
            },

            monitor: {
                required: true
            }
        },

        mounted() {
            this.init();

            window.Echo.channel('job-monitor.motorstats_environment_update')
                .listen('JobMonitorStatusUpdated', (echo) => {
                    this.updateMessage = echo.monitor.message;
                });

            window.Echo.channel('environment.' + _.replace(this.environment.name.toLowerCase(), ' ', ''))
                .listen('EnvironmentUpdated', (echo) => {
                    this.environment = echo.environment;
                    this.showMenu = true;
                    this.updating = false;
                    this.updateMessage = '';
                });

            bus.$on('overlay-clicked', () => {
                this.showActions = false;
            });
        },

        computed: {
            classes() {
                return {
                    'Environment': true,
                    'Environment--online': this.environment.status == 'Online',
                    'Environment--offline': this.environment.status == 'Offline',
                    'Environment--pre-live': this.environment.status == 'Pre-Live',
                }
            },

            formattedDataUpTo() {
                let date = _.isObject(this.environment.dataUpTo) ?
                    this.environment.dataUpTo.date.substring(0, 19) : this.environment.dataUpTo;

                return moment(date).format('DD-MM-YYYY');
            },

            formattedLastUpdated() {
                let date = '';

                if (_.isObject(this.environment.lastUpdated)) {
                    date = this.environment.lastUpdated.date;
                } else {
                    date = this.environment.lastUpdated;
                }

                return moment(date).format('DD-MM-YYYY @ HH:mm:ss');
            },

            updatesClasses() {
                return {
                    'Environment__updates': true,
                    'Environment__updates--pre-live': this.environment.name === 'Pre-Live',
                }
            },
        },

        methods: {
            init() {
                if (this.monitor) {
                    this.showMenu = false;
                    this.updating = true;
                    this.updateMessage = this.monitor.message;
                }

                this.environment.name = this.environmentData.name;
                this.environment.status = this.environmentData.status;
                this.environment.version = this.environmentData.version;
                this.environment.dataUpTo = this.environmentData.data_up_to;
                this.environment.lastUpdated = this.environmentData.updated_at;
            },

            toggleActions() {
                this.showActions = true;

                bus.$emit('show-overlay');
            },

            hideActions() {
                bus.$emit('hide-overlay');
                this.showActions = false;
            },

            copyPreLive() {
                this.showMenu = false;
                this.hideActions();

                this.$http.post('/system-settings/motorstats/copy-pre-live').then((response) => {
                    this.updateMessage = response.data.message;
                    this.updating = true;
                });
            },

            swapEnvironments() {
                this.showMenu = false;
                this.hideActions();

                this.$http.post('/system-settings/motorstats/swap-environments').then((response) => {
                    this.updateMessage = response.data.message;
                    this.updating = true;
                });
            },

            copyPreLiveAndSwap() {
                this.showMenu = false;
                this.hideActions();

                this.$http.post('/system-settings/motorstats/copy-and-swap').then((response) => {
                    this.updateMessage = response.data.message;
                    this.updating = true;
                });
            },

            updateDate() {
                this.showMenu = false;
                this.hideActions();
                this.manualUpdate = true;

                _.defer(() => {
                    this.$refs.manualDate.$el.focus();
                    this.$refs.manualDate.$el.setSelectionRange(0, 0);
                })
            },

            changeDate() {
                this.manualUpdate = false;
                this.updateMessage = 'Updating environment date...';
                this.updating = true;
                this.showMenu = true;

                this.$http.post('/system-settings/motorstats/update-date', { date: this.manualDate })
                    .then((response) => {
                        this.environment = response.data;
                        this.updating = false;
                        this.updateMessage = '';
                        this.manualDate = '';
                    })
                    .catch(error => {
                        console.log(error.data);
                    });
            },

            cancelManualUpdate() {
                this.showMenu = true;
                this.manualUpdate = false;
                this.manualDate = '';
            }
        }
    }
</script>